export interface WxShareInfo {
  c2cShareCode: string;
  shortUrlForCopy: string;
  wxShareUrl: string;
}

export enum C2CShareType {
  /** 作为分享者 */
  'C2CSharer' = 'C2CSharer',
  /** 作为受邀者 */
  'C2CInvitee' = 'C2CInvitee',
}

/** 分享者分享行为 */
export enum C2CSharerAction {
  /** 分享者点击分享 */
  'share' = 'share',
  /** 分享者点击复制 */
  'copy' = 'copy',
}
